import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, NotificationService } from 'yt-ng-framework';
import { WesternUnion } from './western-union';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { Validators } from '@angular/forms';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-western-union-update',
  templateUrl: './western-union-update.component.html'
})
export class WesterUnionUpdateComponent extends BaseUpdateComponent<WesternUnion> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) { 
    super(activatedRoute, baseDataService, toastrService, translateService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc("Datum", Validators.required, 'required', 'WESTERNUNION.DATUM.VALIDATION.REQUIRED');
    this.addValidatorToFc("UkupnoIsplataRsd", Validators.required, 'required', 'WESTERNUNION.UKUPNOISPLATARSD.VALIDATION.REQUIRED');
    this.addValidatorToFc("UkupnoUplata", Validators.required, 'required', 'WESTERNUNION.UKUPNOUPLATA.VALIDATION.REQUIRED');
    this.addValidatorToFc("UkupnoProvizija", Validators.required, 'required', 'WESTERNUNION.UKUPNOPROVIZIJA.VALIDATION.REQUIRED');

    this.IDProcessed
    .subscribe((value) => {
        if (value && this.Item.ID == -1) {
            let dateNow = new Date();
            let date: NgbDate = new NgbDate(dateNow.getFullYear(), dateNow.getMonth() + 1, dateNow.getDate());
            this.baseFormGroup.patchValue({ Datum: date });
            this.baseFormGroup.get('Datum').updateValueAndValidity();
        }
    })

  }

}
